var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SubAPI } from "./SubAPI";
import { sleep } from "nate-react-api-helpers";
export class QuotePricing extends SubAPI {
    getWithAutoRetry(path, input) {
        return __awaiter(this, void 0, void 0, function* () { for (let i = 0; i < 10; i++) {
            try {
                return yield this.fetcher.get(path, input);
            }
            catch (e) {
                if (e.toString().indexOf("503 Service Unavailable") !== -1) {
                    yield sleep(1000);
                    continue;
                }
                throw e;
            }
        } throw new Error("Waiting for background process to calculate prices. Refresh the page to check if it's done yet."); });
    }
    list(props) { return this.getWithAutoRetry("/api/quote-pricing", props); }
    summary(props) { return this.getWithAutoRetry("/api/quote-pricing/summary", props); }
    upsert(input) { return this.fetcher.post("/api/quote-pricing/item", input); }
    upsertMultiple(input) { return this.fetcher.post("/api/quote-pricing/items", input); }
    listOpeningsForProduct(props) { return this.getWithAutoRetry("/api/quote-pricing/openings-for-product", props); }
    scaleSection(props) { return this.fetcher.post("/api/quote-pricing/section-total-price", props); }
    listRiders(props) { return this.getWithAutoRetry("/api/quote-price-rider", props); }
    upsertRider(input) { return this.fetcher.post("/api/quote-price-rider/item", input); }
}
